import type { FaireProductEntity } from "../../entity_types/product";

export const p_vy6kbe49tp: FaireProductEntity = {
  token: "p_vy6kbe49tp",
  type: "product",
  name: "Chronic Fatigue - Loose Leaf Herbal Tea",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/f674a68dba20a2d309203e826b0d69bb609fccb05ba74ea3ecb3dc47748dc58a.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.06,
  description:
    " * Organic and Wild Crafted Herbs \n * Naturally Caffeine Free \n * Promotes Relief From Chronic Fatigue \n * Loose leaf tea provides 40-60 servings \n\nDealing with chronic fatigue is, well, exhausting! The herbs in this blend are designed to work together to fuel and replenish your body while giving you a little energy lift without the use of caffeine or other stimulants (which later make you more tired). Drink daily to and feel results quickly! Tasty too! ",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:58.951Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
